import { PreferencesList } from './Components/PreferencesList/PreferencesList';

export const Preferences = () => {
  return <PreferencesList />;
};
